






















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";

const namespace: string = "reply";

type ActionProps = {
  kekGiven: boolean;
  keks: number;
};

@Component
export default class ReplyActions extends Vue {
  @Prop() action!: ActionProps;
  @Prop() replyPublicId!: string;

  @Action("unlike", { namespace })
  private unlikeReplyVuex!: Function;

  @Action("like", { namespace })
  private likeReplyVuex!: Function;

  private kekGiven: boolean = this.action.kekGiven;
  private keks: number = this.action.keks;

  private likeReply() {
    this.kekGiven = true;
    this.keks++;

    this.likeReplyVuex(this.replyPublicId);
  }

  private unlikeReply() {
    this.kekGiven = false;
    this.keks--;

    this.unlikeReplyVuex(this.replyPublicId);
  }

  private toggleKek() {
    // If reply already liked
    if (this.kekGiven) {
      // Unlike
      this.unlikeReply();
    } else {
      // Like
      this.likeReply();
    }
  }
}
